export default {
  MISS: `Sorry I'm not sure what you're trying to ask me. Try re-phrasing your question, and I’ll do my best to answer or ask to speak to a human!`,
  MISS_PASS_TO_HUMAN_DISABLED: `Sorry I'm not sure what you're trying to ask me. Try re-phrasing your question, and I'll do my best to answer!`,
  COMPLAINT: `Sorry to hear that 🙁 Try asking it in another way or ask to speak to a human.`,
  COMPLAINT_PASS_TO_HUMAN_DISABLED: `Sorry to hear that 🙁 Try re-phrasing your question, and I'll do my best to answer!`,
  PASS_TO_HUMAN: `Ok, I've passed this onto a human. Someone will be in touch soon.`,
  PASS_TO_HUMAN_DISABLED: `Sorry, there are no agents available to pass you to. Try re-phrasing your question, and I'll do my best to answer!`,
  USEFUL_MESSAGE:
    'Great! Glad I could help. Feel free to ask further questions.',
  BOT_CAPABILITIES: `Please feel free to ask any questions, and I'll do my best to answer!`,
  CANCELLATION: `OK no problem, I've cancelled that for you.  Feel free to ask me anything else now.`,
};
